import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@mui/material/Grid';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

import ModeEditIcon from '@mui/icons-material/ModeEdit';
import EditBillingAddressModal from '../Modals/EditBillingAddressModal';
import EditDeliveryAddressModal from '../Modals/EditDeliveryAddressModal';
import { getCodeTranslation } from '../../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import './Invoice.css';
import { useSelector } from 'react-redux';

import { useGetCodeTranslationQuery } from '../../../redux/apis/getCodeTranslation.api';

function AddressDetails({
  data,
  deliveryAddressDetails,
  billingAddressDetails,
  registrationType,
  setBillingAddressDetails,
  setStateArr,
  setDistrictArr,
  setCountryArr,
  setDeliveryAddressDetails,
  setData,
  invoiceEntry,
  partyDeliveryAddressEntity,
  Type,
  partyType,
  partyCategery,
  stateArr,
  countryArr,
  districtArr,
  cityArr,setCityArr,
  getPartyDeliveryAddressDetails,
}) {
  
  function isEmptyDeliveryAddress(details) {

    const { deliveryAddress, states, district, country, pincode, stateCD, countryCD, districtCD, gstin, customerName } = details;

    const isEmptyVal = (val) => {
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim() === '' || val === '0';
      if (typeof val === 'object') {
        return Object.values(val).every((v) => v === '' || v === null || v === undefined || v === '0');
      }
      return false;
    };

    return (
      isEmptyVal(deliveryAddress) &&
      isEmptyVal(states?.value) &&
      isEmptyVal(district?.value) &&
      isEmptyVal(country?.value) &&
      isEmptyVal(pincode) &&
      isEmptyVal(stateCD) &&
      isEmptyVal(countryCD) &&
      isEmptyVal(districtCD) &&
      isEmptyVal(gstin) &&
      isEmptyVal(customerName)
    );
  }
  const isConsigneeEmpy= data?.consigneeName ==='' || data?.consigneeGST==='';
  const isEmptyInvDeliveryAddress = isEmptyDeliveryAddress(deliveryAddressDetails);
  const isEmptyPartyDelivery =
    !partyDeliveryAddressEntity ||
    (Object.keys(partyDeliveryAddressEntity).length === 0 && partyDeliveryAddressEntity.constructor === Object);
  const isAdrressEmpty = !isEmptyInvDeliveryAddress || !isEmptyPartyDelivery || !isConsigneeEmpy;
  const objectType = Type === 'Purchase' ? 'PurchaseBilling' : 'Sales' ? 'SalesBilling' : 'CreditNote' ? 'CreditBilling' : 'DebitBilling';
  const delObjectType =
    Type === 'Purchase' ? 'PurchaseDelivery' : 'Sales' ? 'SalesDelivery' : 'CreditNote' ? 'CreditDelivery' : 'DebitDelivery';
  const invoiceID = Type === 'Purchase' ? invoiceEntry?.purchaseid : 'Sales' ? invoiceEntry?.invoiceid : invoiceEntry?.crdrnoteid;
  const delAddressType = invoiceEntry?.length === 0 ? 'PartyDelivery' : delObjectType;
  const addressType = invoiceEntry?.length === 0 ? 'PartyBilling' : objectType;
  const addressID = invoiceEntry?.length === 0 ? data.partyName?.value : invoiceID;
  const [types, setTypes] = useState('');
  const [addressToFetch, setAddressToFetch] = useState({
    state: 'KeralaDistrict',
    country: 'IndiaState',
  });
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [openDeliveryAddressModal, setOpeneliveryAddressModal] = useState(false);
  const [arrOfBillAddrs, setArrOfBillAddrs] = useState('');
  const [arrOfDellAddrs, setArrOfDellAddrs] = useState('');
  const [tempbillingAddressDetails, setTempBillingAddressDetails] = useState({
    billingAddress: '',
    states: { label: '', value: '' },
    district: { label: '', value: '' },
    country: { label: '', value: '' },
    city: { label: '', value: '' },

    pincode: '',
    stateCD: '',
    countryCD: '',
    cityCD:'',
    districtCD: '',
    gstin: '',
    customerName: '',

    errorStatus: {
      billingAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      billingAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      customerName: '',
    },
  });
  const [tempdeliveryAddressDetails, setTempDeliveryAddressDetails] = useState({
    deliveryAddress: '',
    states: { label: '', value: '' },
    district: { label: '', value: '' },
    country: { label: '', value: '' },
    pincode: '',
    stateCD: '',
    countryCD: '',
    districtCD: '',
    gstin: '',
    customerName: '',

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      deliveryAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      customerName: '',
    },
  });
  let stateValue = useSelector((state) => state);
  async function getStates(code) {
    const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));
    if (cities?.data?.getCodeTranslation != null) {
      let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}District`,
          code: element?.statecode,
        };
      });
      setStateArr(statesArray);
    }
  }
  const {
    data: countriesList,
    isLoading: isCountryListLoading,
    isError: isCountriesListError,
  } = useGetCodeTranslationQuery({ codetype: 'Country' });

  const {
    data: stateList,
    isLoading: isStateLoading,
    isError: isStateError,
  } = useGetCodeTranslationQuery({ codetype: 'IndiaState' }, { skip: !addressToFetch.country });
  const {
    data: districtList,
    isLoading: isDistrictListLoading,
    isError: isDistrictListError,
  } = useGetCodeTranslationQuery({ codetype: 'KeralaDistrict' }, { skip: !addressToFetch.state });
  useMemo(() => {
    if (!countriesList) return [];
    let countriesArray = countriesList.map((element) => {
      return {
        label: element.codetext,
        value: `${element.codetext}State`,
      };
    });
    setCountryArr(countriesArray);
  }, [countriesList]);
  useMemo(() => {
    if (!stateList) return [];
    let statesArray = stateList.map((element) => {
      return {
        label: element.codetext,
        value: `${element.codetext}District`,
        code: element?.statecode,
      };
    });
    setStateArr(statesArray);
  }, [stateList]);
  useMemo(() => {
    if (!districtList) return [];
    let disArray = districtList.map((element) => {
      return {
        label: element.codetext,
        value: `${element.codetext}District`,
      };
    });
    setDistrictArr(disArray);
  }, [districtList]);
  async function getDistricts(state) {
    try {
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: state }));

      let disArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}District`,
        };
      });
      setDistrictArr(disArray);
    } catch (error) {}
  }
  
  const copyBillingToDelivery = () => {
  setDeliveryAddressDetails({
    ...billingAddressDetails,
    deliveryAddress: billingAddressDetails.billingAddress,
    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      deliveryAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      customerName: '',
    },
  });
  setTempDeliveryAddressDetails({
  // main fields
  deliveryAddress: billingAddressDetails.billingAddress,
  states: billingAddressDetails.stateCD,
  district: billingAddressDetails.districtCD,
  country: billingAddressDetails.countryCD,
  pincode: billingAddressDetails.pincode,
  stateCD: billingAddressDetails.stateCD,
  countryCD: billingAddressDetails.countryCD,
  districtCD: billingAddressDetails.districtCD,
  gstin: data?.gstin,
 city: billingAddressDetails.cityCD,
        cityCD: billingAddressDetails.cityCD,
  customerName: data.partyName?.label,

  // reset errorStatus
  errorStatus: {
    deliveryAddress: false,
    states: false,
    district: false,
    country: false,
    pincode: false,
    gstin: false,
    customerName: false,
  },

  // reset errorFields
  errorFields: {
    deliveryAddress: '',
    states: '',
    district: '',
    country: '',
    pincode: '',
    gstin: '',
    customerName: '',
  },
});

};
const saveTempAddressDetails=()=>{
  setTempDeliveryAddressDetails({
  deliveryAddress: deliveryAddressDetails.deliveryAddress,
  states: deliveryAddressDetails.stateCD,
  district: deliveryAddressDetails.districtCD,
  country: deliveryAddressDetails.countryCD,
  pincode: deliveryAddressDetails.pincode,
  stateCD: deliveryAddressDetails.stateCD,
  countryCD: deliveryAddressDetails.countryCD,
  districtCD: deliveryAddressDetails.districtCD,
    city:deliveryAddressDetails.cityCD,
     cityCD:deliveryAddressDetails.cityCD,
  gstin: deliveryAddressDetails?.gstin,
  customerName: deliveryAddressDetails?.customerName,
  errorStatus: {
    deliveryAddress: false,
    states: false,
    district: false,
    country: false,
    pincode: false,
    gstin: false,
    city:'',
    customerName: false,
  },

  errorFields: {
    deliveryAddress: '',
    states: '',
    district: '',
    country: '',
    pincode: '',
    gstin: '',
    city:'',
    customerName: '',
  },
});
 setTempBillingAddressDetails({
  billingAddress: billingAddressDetails.billingAddress,
  states: billingAddressDetails.stateCD,
  district: billingAddressDetails.districtCD,
  country: billingAddressDetails.countryCD,
  pincode: billingAddressDetails.pincode,
  stateCD: billingAddressDetails.stateCD,
  countryCD: billingAddressDetails.countryCD,
  districtCD: billingAddressDetails.districtCD,
  gstin: billingAddressDetails?.gstin,
    city: billingAddressDetails.cityCD,
        cityCD: billingAddressDetails.cityCD,
  customerName: billingAddressDetails?.customerName,
  errorStatus: {
    deliveryAddress: false,
    states: false,
    district: false,
    country: false,
    pincode: false,
    gstin: false,
    customerName: false,
    city:false
  },

  errorFields: {
    deliveryAddress: '',
    states: '',
    district: '',
    country: '',
    pincode: '',
    gstin: '',
    city:'',
    customerName: '',
  },
});
};
useEffect(()=>{
 saveTempAddressDetails()
},[deliveryAddressDetails,billingAddressDetails])
  useEffect(() => {
    let billObj = [];
    let filterBilloBj = [];
    let deliveryObj = [];
    let filterDeliveryObj = [];
    if (data.partyName.value !== '') {
      billObj.push(data.partyName.label);
    }
    if (billingAddressDetails.billingAddress !== '') {
      billObj.push(billingAddressDetails.billingAddress);
    }
      if (billingAddressDetails?.city?.label !== '') {
      billObj.push(billingAddressDetails?.city?.label);
    }
    if (billingAddressDetails.districtCD.value !== '') {
      billObj.push(billingAddressDetails.districtCD.label);
    }
  
    if (billingAddressDetails.stateCD.value !== '') {
      billObj.push(billingAddressDetails.stateCD.label);
    }
    if (billingAddressDetails.countryCD.value !== '') {
      billObj.push(billingAddressDetails.countryCD.label);
    }
    if (billingAddressDetails.pincode !== '') {
      billObj.push(billingAddressDetails.pincode);
    }

    if (billObj.length > 0) {
      billObj.filter((ele) => {
        if (ele !== '' && ele !== undefined && ele !== null) {
          filterBilloBj.push(ele);
        }
      });

      setArrOfBillAddrs(filterBilloBj);
    }
    if (isAdrressEmpty) {
      if (!data?.sameAsBilling) {
        deliveryObj.push(data.consigneeName);
      } else {
        deliveryObj.push(data.partyName.label);
      }
      if (deliveryAddressDetails.deliveryAddress !== '') {
        deliveryObj.push(deliveryAddressDetails.deliveryAddress);
      }
      if (deliveryAddressDetails.city?.label !== '') {
        deliveryObj.push(deliveryAddressDetails?.city?.label);
      }
      if (deliveryAddressDetails.districtCD.value !== '') {
        deliveryObj.push(deliveryAddressDetails.districtCD.label);
      }
      

      if (deliveryAddressDetails.stateCD.value !== '') {
        deliveryObj.push(deliveryAddressDetails.stateCD.label);
      }

      if (deliveryAddressDetails.countryCD.value !== '') {
        deliveryObj.push(deliveryAddressDetails.countryCD.label);
      }

      if (deliveryAddressDetails.pincode !== '') {
        deliveryObj.push(deliveryAddressDetails.pincode);
      }
      if (deliveryObj.length > 0) {
        deliveryObj.filter((ele) => {
          if (ele !== '' && ele !== undefined && ele !== null) {
            filterDeliveryObj.push(ele);
          }
        });

        setArrOfDellAddrs(filterDeliveryObj);
      }
    }
  }, [billingAddressDetails, deliveryAddressDetails, data?.sameAsBilling]);

  return (
    <>
      <Grid item lg={4} xs={12}>
        <Box
          sx={{
            flex: { xs: 1, sm: 1 },
            color: 'primary.main',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <span
              style={{
                color: 'primary.main',
                fontWeight: 'bold',
                fontSize: '14px',
              }}
            >
              {Type !== 'Purchase' ? 'Billing Address' : 'Supplier Address'}
            </span>
            {data.partyName.value !== '' && (
              <span
                onClick={() => {
                  if (Type === 'Sales') {
                    setTypes('SalesBilling');
                  }
                  if (Type === 'Purchase') {
                    setTypes('PurchaseBilling');
                  }
                  setOpenAddressModal(true);
                }}
                style={{ paddingLeft: '14px' }}
              >
                <ModeEditIcon fontSize="10px" sx={{ cursor: 'pointer', color: '#6096d9' }} />
              </span>
            )}
          </Box>
          <span
            style={{
              fontSize: '12px',
              flex: 1,
              mb: 1,
            }}
          >
            {data.partyName.value !== '' && arrOfBillAddrs.length > 0 && (
              <Box
                className="custom-scrollbar"
                sx={{
                  flex: 1,
                  maxHeight: 60,
                  overflowY: 'auto',
                  width: '1005',
                }}
              >
                <span style={{ color: 'primary.main' }}>
                  {arrOfBillAddrs.slice(0, 2).join(', ')}
                  <br />
                  {arrOfBillAddrs.slice(2).join(', ')}
                </span>
              </Box>
            )}
          </span>
        </Box>
      </Grid>
      {/* {Type !== "Purchase" && ( */}
      <>
        <Grid item lg={4} xs={12}>
          <Box
            sx={{
              flex: { xs: 1, sm: 1 },
              color: 'primary.main',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5, // vertical alignment
              }}
            >
              <span
                style={{
                  color: 'primary.main',
                  fontWeight: 'bold',
                  fontSize: '14px',
                }}
              >
                {partyType === 'SUPPLIER' ? 'Ship From Address' : 'Ship To Address'}
              </span>

              {data.partyName.value !== '' && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {isAdrressEmpty && arrOfDellAddrs.length > 0 ? (
                    <ModeEditIcon
                      fontSize="10px" // keeps consistent with checkbox
                      sx={{ cursor: 'pointer', color: '#6096d9' }}
                      onClick={() => {
                        setTypes('SalesDelivery');
                        setOpeneliveryAddressModal(true);
                      }}
                    />
                  ) : (
                    <>
                      <ModeEditIcon
                        fontSize="10px"
                        sx={{ cursor: 'pointer', color: '#6096d9' }}
                        onClick={() => {
                          setTypes('SalesDelivery');
                          setOpeneliveryAddressModal(true);
                        }}
                      />
                      <FormControlLabel
                        sx={{
                          margin: 0, // remove extra gap from label
                          color: 'primary.main',
                          fontWeight: 'bold',
                          fontSize: '14px',
                          '& .MuiCheckbox-root': {
                            padding: 0, // shrink spacing
                            color: '#6096d9',
                            '&.Mui-checked': {
                              color: '#6096d9',
                            },
                          },
                        }}
                        control={
                          <Checkbox
                            size="small"
                            sx={{
                              '& .MuiSvgIcon-root': { fontSize: 16 }, // make checkbox tick ~same as icon
                            }}
                            checked={data?.sameAsBilling}
                            onChange={(e) => {
                              setData((prev) => ({
                                ...prev,
                                sameAsBilling: e.target.checked,
                                consigneeName: e.target.checked === true ? data?.partyName?.label : '',
                                consigneeGST: e.target.checked === true ? data?.gstin : '',
                              }));
                              if (e.target.checked) {
                              //   getPartyDeliveryAddressDetails(addressID, addressType);
                              // } else {
                              //   getPartyDeliveryAddressDetails(addressID, delAddressType);
                              // }
                              copyBillingToDelivery();
}
                            }}
                          />
                        }
                        label={
                          <span
                            style={{
                              color: 'primary.main',
                              fontWeight: 'bold',
                              fontSize: '14px',
                            }}
                          >
                            {' '}
                            {Type !== 'Purchase' ? 'Same as Billing Address' : 'Same as Supplier Address'}{' '}
                          </span>
                        }
                      />
                    </>
                  )}
                </Box>
              )}
            </Box>

            <span
              style={{
                fontSize: '12px',
                flex: 1,
                mb: 1,
              }}
            >
              <Box
                className="custom-scrollbar"
                sx={{
                  flex: 1,
                  maxHeight: 60,
                  width: '100 %',
                  overflowY: 'auto',
                }}
              >
                {' '}
                {isAdrressEmpty && data.partyName.label !== '' && arrOfDellAddrs.length > 0 && (<>
                  <span style={{ color: 'primary.main' }}>
                    {arrOfDellAddrs.slice(0, 2).join(', ')}
                    <br />
                    {arrOfDellAddrs.slice(2).join(', ')}
                  </span><br />
                     {((partyCategery !== 'UB' || registrationType !== 1) && (data?.consigneeGST !== '' || !data.sameAsBilling)) &&
                    <span style={{ color: 'primary.main' }}>GSTIN:{data?.consigneeGST??''}
                  </span>
                  }
                  </>
                )}
              </Box>
            </span>
          </Box>
        </Grid>
      </>
      {/* )} */}
      {openAddressModal === true && (
        <EditBillingAddressModal
          open={openAddressModal}
          setOpen={setOpenAddressModal}
          setStateArr={setStateArr}
          setDistrictArr={setDistrictArr}
          setCityArr={setCityArr}
          cityArr={cityArr}
          setCountryArr={setCountryArr}
          partyID={data.partyName.value}
          setBillingAddressDetails={setBillingAddressDetails}
          data={data}
          addressType={
            Type === 'Sales'
              ? 'SalesBilling'
              : Type === 'Purchase'
              ? 'PurchaseBilling'
              : Type === 'CreditNote'
              ? 'CreditBilling'
              : 'DebitBilling'
          }
          invoiceEntry={invoiceEntry}
          setData={setData}
          registrationType={registrationType}
          Type={Type}
          stateArr={stateArr}
          partyType={partyType}
          countryArr={countryArr}
          districtArr={districtArr}
          getStates={(value) => getStates(value)}
          getDistricts={(value) => getDistricts(value)}
          tempbillingAddressDetails={tempbillingAddressDetails}
          setTempBillingAddressDetails={setTempBillingAddressDetails}
          setAddressToFetch={setAddressToFetch}
          stateList={stateList}
          countriesList={countriesList}
        />
      )}

      {openDeliveryAddressModal === true && (
        <EditDeliveryAddressModal
          open={openDeliveryAddressModal}
          setOpen={setOpeneliveryAddressModal}
          setStateArr={setStateArr}
          setDistrictArr={setDistrictArr}
           setCityArr={setCityArr}
           cityArr={cityArr}
          setCountryArr={setCountryArr}
          partyID={data.partyName.value}
          partyType={partyType}
          setDeliveryAddressDetails={setDeliveryAddressDetails}
          data={data}
          addressType={
            Type === 'Sales'
              ? 'SalesDelivery'
              : Type === 'Purchase'
              ? 'PurchaseDelivery'
              : Type === 'CreditNote'
              ? 'CreditDelivery'
              : 'DebitDelivery'
          }
          invoiceEntry={invoiceEntry}
          setData={setData}
          Type={Type}
          registrationType={registrationType}
          stateArr={stateArr}
          countryArr={countryArr}
          districtArr={districtArr}
          getStates={(value) => getStates(value)}
          getDistricts={(value) => getDistricts(value)}
          tempdeliveryAddressDetails={tempdeliveryAddressDetails}
          setTempDeliveryAddressDetails={setTempDeliveryAddressDetails}
          setAddressToFetch={setAddressToFetch}
          stateList={stateList}
          countriesList={countriesList}
          partyDeliveryAddressEntity={partyDeliveryAddressEntity}
          deliveryAddressDetails={deliveryAddressDetails}
        />
      )}
    </>
  );
}

export default AddressDetails;
